import { computed, defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import { AssignmentAction, AssignmentGetter } from '@/store/assignment/assignment.module';
import LoadingComponent from '@/components/loading/Loading.vue';
import AssignmentTableComponent from '@/components/assignmentTable/AssignmentTable.vue';

export default defineComponent({
  name: 'AssignmentRegionPage',
  components: {
    LoadingComponent,
    AssignmentTableComponent,
  },
  setup: () => {
    const store = useStore();
    const isLoading = computed(() => store.getters[AssignmentGetter.STATUS] === 'init' || store.getters[AssignmentGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(AssignmentAction.FETCH, { mode: 'REGION' });
    });

    return {
      isLoading,
    };
  },
});
